import React, { useEffect, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

import "./simpleUploadModal.scss";

const SimpleUploadModal = ({
  icon,
  image,
  text,
  subText,
  additionalText,
  buttonText,
  buttonCallback,
  isCancel,
  cancelText,
  cancelCallback,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { name, ...rest } = icon || image;

  const handleCancel = () => {
    cancelCallback && cancelCallback();
    closeModal();
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    await buttonCallback();
    setIsLoading(false);
  };

  useEffect(() => {
    return () => {
      cancelCallback && cancelCallback();
    };
  }, []);

  return (
    <div className="simple-upload-modal">
      <div className="icon-container">
        {image ? (
          <Image name={name} {...rest} />
        ) : (
          <Icon name={name} {...rest} />
        )}
      </div>
      <div className="modal-text">{getTextByKey(text)}</div>
      {additionalText ? (
        <div className="modal-sub-text">{additionalText}</div>
      ) : null}
      {subText ? (
        <div className="modal-sub-text">{getTextByKey(subText)}</div>
      ) : null}
      <div className="modal-button-container">
        {isCancel ? (
          <Button className="cancel-button" onClick={handleCancel}>
            {getTextByKey(cancelText || "cancel-text")}
          </Button>
        ) : null}
        {buttonText ? (
          isLoading ? (
            <LoadingContainerElement />
          ) : (
            <Button className="modal-button" onClick={handleConfirm}>
              {getTextByKey(buttonText)}
            </Button>
          )
        ) : null}
      </div>
    </div>
  );
};

export default SimpleUploadModal;
